import * as React from "react";
import { withOpenState, OpenStateInjectedProps } from "ui/common/enhancers/with-open-state";
import { ModalWrapper } from "app/components/modal-wrapper/modal-wrapper";
import { ModalSize } from "app/components/constants";
import { useNavigate } from "react-router-dom";
import styles from "./case-view-modal.scss";
import { routeConstants } from "app/routes/route-constants";
interface CaseViewModalProps {
  children?: any;
  favouriteId?: number;
  dashboardType?: number;
  bowtieId?: number;
}

export type CaseViewModalComponentProps = CaseViewModalProps & OpenStateInjectedProps;
export const CaseViewModalComponent = (props: CaseViewModalComponentProps) => {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  React.useEffect(() => {

    if (!props.isOpen) {
      props.open();
    }
  }, []);

  const closeModal = () => {
    const favouritePath = props.dashboardType ? routeConstants.dashboardWithFavouriteFor(props.dashboardType, props.favouriteId) :
    props.bowtieId ? routeConstants.bowtieViewFor(props.bowtieId) : 
    routeConstants.favouriteViewFor(Number(props.favouriteId));
    props.close();
    navigate(`${favouritePath}?${searchParams.toString()}`);
  };

  const modalView = React.useMemo(() => (
    <ModalWrapper onClose={closeModal} size={ModalSize.xtraLarge}>
      <div className={styles.caseViewModalContent}>
        {props.children}
      </div>
    </ModalWrapper>
  ), [props.children]);

  return (
    <>
      <div id="caseViewModal" className={styles.caseViewModal}>
        {props.isOpen && modalView}
      </div>
    </>
  );
};

export const CaseViewModal = withOpenState()(CaseViewModalComponent);
